import { toLuxonDateTime } from '@fullcalendar/luxon2'
import { toLuxonDateTimeKeepingSameTime } from './helpers'

export const syncDatePickerAndFullCalendar = (
  fullcalendar,
  datePickerController
) => {
  syncDatePickerOnFullCalendarChange(fullcalendar, datePickerController)
  syncFullCalendarOnDatePickerSelect(fullcalendar, datePickerController)
}

// When navigating to a new month on fullcalendar, let's update the date picker to that month, but only if the selected date is not within the current fullcalendar view date...
const syncDatePickerOnFullCalendarChange = (
  fullcalendar,
  datePickerController
) => {
  fullcalendar.on('datesSet', (info) => {
    const fcStartLuxon = toLuxonDateTime(info.start, fullcalendar)
    const fcEndLuxon = toLuxonDateTime(info.end, fullcalendar)

    const datePickerDateLuxon = toLuxonDateTimeKeepingSameTime(
      datePickerController.getSelectedDate() ||
        datePickerController.getViewDate(),
      fullcalendar
    ).startOf('day')

    if (
      datePickerDateLuxon >= fcStartLuxon &&
      datePickerDateLuxon <= fcEndLuxon
    )
      return

    const date = toLuxonDateTime(info.end, fullcalendar)
      .minus({ days: 1 })
      .setZone('local', { keepLocalTime: true })
      .toJSDate()

    datePickerController.gotoDate(date)
  })
}

// When selecting a date on the date picker, let's switch the fullcalendar view to that date
const syncFullCalendarOnDatePickerSelect = (
  fullcalendar,
  datePickerController
) => {
  datePickerController.onDateSelect((date) => {
    if (!date) return
    const luxon = toLuxonDateTimeKeepingSameTime(date, fullcalendar)
    fullcalendar.gotoDate(luxon.toJSDate())
  })
}
